<template>
  <SysDialog
    v-model="dialog_ativo"
    titulo="Novos E-mails"
    @click:primary="salvarEmails"
  >
    <template #ativador>
      <v-btn color="primary" small @click="dialog_ativo = ! dialog_ativo">
        <v-icon :size="20" class="mr-1">mdi-plus</v-icon>
        Novo
      </v-btn>
    </template>

    <GruposSeparacaoAutocomplete
      v-model="item.idgrupo"
      :error-messages="buscarMensagensErros($v.item.idgrupo)"
    />

    <FilialGrupoSeparacaoAutocomplete
      v-if="dialog_ativo"
      v-model="item.filiais"
      :grupos="[item.idgrupo]"
      :error-messages="buscarMensagensErros($v.item.filiais)"
    />

    <EmailsAutocomplete
      v-model="item.emails.cd"
      label="E-mails do tipo CD"
      outlined
      :error-messages="buscarMensagensErros($v.item.emails.cd)"
    />

    <EmailsAutocomplete
      v-model="item.emails.filiais"
      label="E-mails do tipo Filial"
      outlined
      :error-messages="buscarMensagensErros($v.item.emails.filiais)"
    />
  </SysDialog>
</template>

<script>
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import GruposSeparacaoAutocomplete from "@/components/drp/configDrpAutomatizado/GrupoSeparacao/GrupoSeparacaoAutocomplete.vue";
import FilialGrupoSeparacaoAutocomplete from "@/components/drp/configDrpAutomatizado/FilialGrupoSeparacao/FilialGrupoSeparacaoAutocomplete.vue";
import EmailsAutocomplete from "@/components/drp/configDrpAutomatizado/WorkflowEmail/EmailsAutocomplete.vue";
import {required} from "vuelidate/lib/validators";
import * as req from "@/api/drp/SeparacaoAutomatica/Emails";
import {logout} from "@/helpers";

export default {
  components: {
    SysDialog,
    GruposSeparacaoAutocomplete,
    FilialGrupoSeparacaoAutocomplete,
    EmailsAutocomplete
  },
  emits: ['novo-cadastro'],
  props: {
    item_para_edicao: Object,
  },
  data: () => ({
    dialog_ativo: false,
    item: {
      idgrupo: '',
      filiais: [],
      emails: {
        cd: [],
        filiais: []
      },
    }
  }),
  validations: {
    item: {
      idgrupo: { required },
      filiais: { required },
      emails: {
        cd: { required },
        filiais: { required },
      },
    }
  },
  watch: {
    item_para_edicao() {
      if (!this.item_para_edicao.idgrupo) return;
      this.item = Object.assign({}, this.item_para_edicao);
      this.dialog_ativo = true;
    }
  },
  methods: {
    buscarMensagensErros(campo) {
      if (!campo.$dirty) return '';

      if ((campo.$params.required !== undefined) && !campo.required) {
        return  'Campo Obrigatório.';
      }

      return '';
    },
    salvarEmails() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      this.$store.dispatch('loading/addRequisicao',
        req.salvarEmails(this.item)
          .then(() => {
            this.dialog_ativo = false;
            setTimeout(() => this.$emit('novo-cadastro', {}), 10);
          })
          .catch(logout)
      );
    }
  }
}
</script>

<style scoped>

</style>
